(() => {
  'use strict';
  const root = document.querySelector('.editorial-page');
  if (!root) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = Array.from(root.querySelectorAll('video'));
  const hydrate = video => {
    const source = video.querySelector('source[data-src]');
    if (!source) return;
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
    video.load();
  };
  const updateVideoButton = video => {
    const button = video.parentElement.querySelector('.video-toggle');
    if (!button) return;
    button.textContent = video.paused ? '▶' : 'Ⅱ';
    button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    button.setAttribute('aria-pressed', String(!video.paused));
  };
  const playVisibleVideo = video => {
    hydrate(video);
    if (!reducedMotion.matches && !video.dataset.userPaused && !document.hidden) {
      video.play().catch(() => updateVideoButton(video));
    }
  };
  const videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) playVisibleVideo(entry.target);
      else entry.target.pause();
    });
  }, { threshold: 0.3 }) : null;
  videos.forEach(video => {
    video.addEventListener('play', () => updateVideoButton(video));
    video.addEventListener('pause', () => updateVideoButton(video));
    video.parentElement.querySelector('.video-toggle')?.addEventListener('click', () => {
      hydrate(video);
      if (video.paused) {
        delete video.dataset.userPaused;
        video.play().catch(() => updateVideoButton(video));
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
      }
    });
    videoObserver?.observe(video);
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) videos.forEach(video => video.pause());
  });
  document.addEventListener('visibilitychange', () => {
    videos.forEach(video => {
      if (document.hidden) video.pause();
      else {
        const rect = video.getBoundingClientRect();
        if (rect.width && rect.bottom > 0 && rect.top < innerHeight) playVisibleVideo(video);
      }
    });
  });
  const attribution = new URLSearchParams();
  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (/^utm_[a-z0-9_]+$/i.test(key) || /^(fbclid|gclid)$/i.test(key)) attribution.set(key, value);
  });
  root.querySelectorAll('a[href]').forEach(link => {
    const destination = new URL(link.getAttribute('href'), window.location.href);
    if (destination.origin !== 'https://kittycollective.co' || destination.pathname.replace(/\/$/, '') !== '/products/wingmate') return;
    attribution.forEach((value, key) => destination.searchParams.set(key, value));
    link.href = destination.toString();
  });
  const sticky = root.querySelector('.kc-prelander-sticky');
  const opening = root.querySelector('.editorial-opening');
  if (!sticky || !opening) return;
  let scheduled = false;
  const updateSticky = () => {
    scheduled = false;
    const visible = opening.getBoundingClientRect().bottom <= 0;
    sticky.hidden = !visible;
    sticky.inert = !visible;
    sticky.setAttribute('aria-hidden', String(!visible));
    sticky.classList.toggle('is-visible', visible);
  };
  const requestUpdate = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(updateSticky);
    }
  };
  document.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('pageshow', requestUpdate);
  if ('ResizeObserver' in window) new ResizeObserver(requestUpdate).observe(opening);
  updateSticky();
})();
